import { render, staticRenderFns } from "./surface-activity-indicator.vue?vue&type=template&id=574bcb19&"
import script from "./surface-activity-indicator.vue?vue&type=script&lang=ts&"
export * from "./surface-activity-indicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports